import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import alpha from "Assets/Svg/alpha-numeric.svg";
import dton from "Assets/Svg/date.svg";
import dropdown from "Assets/Svg/dropdown-selection.svg";
import checkboxIcon from "Assets/Svg/list-checkbox.svg";
import num from "Assets/Svg/numerical.svg";
import DynamicForm from "Component/DynamicForm";
import { instance } from "Actions/AxiosInstance";
import { ErrorMessages } from "Constants";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";

import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const questioncategories = [
  {
    displayname: "Company and culture questions",
    displayvalue: 1,
  },
  {
    displayname: "Functional & role question",
    displayvalue: 2,
  },
];

class AddScreeningQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionid:
        (this.props.postData && this.props.postData.questionid) || null,
      questioncategoryid:
        (this.props.postData && this.props.postData.questioncategoryid) || null,
      questiontext:
        (this.props.postData && this.props.postData.questiontext) || null,
      inputvaluetypeid:
        (this.props.postData && this.props.postData.inputvaluetypeid) || 0,
      questioninputoption:
        (this.props.postData &&
          this.props.postData.questioninputoption &&
          this.props.postData.questioninputoption) ||
        [],

      selectedReview: props.selectedReview,
      saveincompany: false,
      // questioncategoryid: null,
      description: "",
      idx: "",
      postData: [{ fields: [{ questioninputoption: [] }] }],
      // questioninputoption: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.setInputType = this.setInputType.bind(this);
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addOption = this.addOption.bind(this);
    this.addMultiOption = this.addMultiOption.bind(this);
    this.removeOption = this.removeOption.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {}

  onCancel() {
    this.props.enqueueSnackbar(
      "You will loss this data, Are you sure you want to cancel this?",
      {
        variant: "warning",
        action: [
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              this.props.onCancel();
              this.props.closeSnackbar();
            }}
          >
            Yes
          </Button>,
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
            }}
          >
            No
          </Button>,
        ],
      },
    );
  }

  onSave() {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    let isoption = false;
    if (this.state.questioninputoption.length > 0) {
      const index = this.state.questioninputoption.findIndex(
        (x) => !x.optionname || !x.optionname.trim(),
      );
      console.log("index: ", index);
      if (index == -1) {
        isoption = true;
      }
    }

    if (!this.state.questioncategoryid) {
      this.props.enqueueSnackbar("Please select Question category", {
        variant: "error",
      });
    } else if (!this.state.questiontext || !this.state.questiontext.trim()) {
      this.props.enqueueSnackbar("Please Enter a question", {
        variant: "error",
      });
    } else if (this.state.inputvaluetypeid == 0) {
      this.props.enqueueSnackbar("Please select answer type", {
        variant: "error",
      });
    } else if (
      (this.state.inputvaluetypeid == 4 || this.state.inputvaluetypeid == 5) &&
      this.state.questioninputoption.length == 0
    ) {
      this.props.enqueueSnackbar("Please add input option", {
        variant: "error",
      });
    } else if (
      this.state.inputvaluetypeid == 4 &&
      this.state.questioninputoption.length == 1
    ) {
      this.props.enqueueSnackbar("Please add atleast 2 input option", {
        variant: "error",
      });
    } else if (this.state.questioninputoption.length > 0 && !isoption) {
      this.props.enqueueSnackbar("Please add option name in every option", {
        variant: "error",
      });
    } else {
      const data = {
        questionid: this.state.questionid,
        questioncategoryid: this.state.questioncategoryid,
        questiontext: this.state.questiontext,
        inputvaluetypeid: this.state.inputvaluetypeid,
        questioninputoption: this.state.questioninputoption.map(
          (item, index) => {
            delete item.questionid;
            item.optionorder = index + 1;
            return item;
          },
        ),
      };
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        instance
          .post("recruit/configquestion", data)
          .then(() => {
            this.props.enqueueSnackbar(ErrorMessages.E0000, {
              variant: "success",
            });
            this.props.removeSaveProgress();
            this.props.history.push(`${this.props.match.path}/list`);
            this.props.getAllQuestion();
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });
      }
    }
  }

  addOption() {
    const { questioninputoption } = this.state;
    questioninputoption.push({
      questioninputoptionid: null,
      optionname: "",
      optionorder: null,
    });
    this.setState({
      questioninputoption,
    });
  }

  addMultiOption() {
    const { questioninputoption } = this.state;
    questioninputoption.push({
      questioninputoptionid: null,
      optionname: "",
      optionorder: null,
    });
    this.setState({
      questioninputoption,
    });
  }

  removeOption(index) {
    const { questioninputoption } = this.state;
    if (questioninputoption) {
      questioninputoption.splice(index, 1);
      this.setState(
        {
          questioninputoption,
        },
        // () => {
        //   this.props.updatePostData(postData);
        // },
      );
    }
  }

  setInputType(inputvaluetypeid) {
    this.setState({
      inputvaluetypeid,
      questioninputoption: [],
    });
  }

  handleChange(key, value, index = null) {
    const { questioninputoption } = this.state;
    if (index != null) {
      questioninputoption[index][key] = value;
      questioninputoption[index].optionorder = index + 1;
      this.setState({
        questioninputoption,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
  }

  onSubmit = () => {};

  render() {
    const {
      questioncategoryid,
      questiontext,
      inputvaluetypeid,
      questioninputoption,
    } = this.state;

    const value =
      inputvaluetypeid == 1
        ? "eg. john smith"
        : inputvaluetypeid == 2
        ? "eg. 123"
        : inputvaluetypeid == 3
        ? "eg. 2000/06/24"
        : inputvaluetypeid == 4
        ? `Select ${questiontext}`
        : "";

    const placeholder = value;

    return (
      <div className="content-outer-wrapper display-flex">
        <div className="width50">
          <DynamicForm
            fields={selectinputconverter({
              value: questioncategoryid,
              placeholder: "",
              label: "Question category",
              options: questioncategories,
            })}
            onChange={(selectedid) => {
              this.handleChange("questioncategoryid", selectedid);
            }}
          />
          {/* {questioncategoryid == 1 && (
          <DynamicForm
            fields={selectinputconverter({
              value: this.state.questioncategoryid,
              placeholder: "",
              label: "Select question",
              options: this.state.questioncategories,
            })}
            onChange={(selectedid) => {
              this.handleChange("questioncategoryid", selectedid);
            }}
          />
        )} */}
          <div>
            <DynamicForm
              className="width50"
              fields={textareainputconverter({
                value: questiontext,
                placeholder: "",
                label: "Enter your question",
              })}
              onChange={(value) => {
                this.handleChange("questiontext", value);
              }}
            />
            <p className="small-dark-secondary margin-bottom-8">Answer type</p>
            <div className="margin-bottom-8">
              <Tooltip title="Text" placement="top-start">
                <img
                  src={alpha}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      inputvaluetypeid == 1
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => this.setInputType(1)}
                ></img>
              </Tooltip>
              <Tooltip title="Numeric" placement="top-start">
                <img
                  src={num}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      inputvaluetypeid == 2
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => this.setInputType(2)}
                ></img>
              </Tooltip>
              <Tooltip title="Date" placement="top-start">
                <img
                  src={dton}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      inputvaluetypeid == 3
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => this.setInputType(3)}
                ></img>
              </Tooltip>
              <Tooltip title="Multi-choice" placement="top-start">
                <img
                  src={dropdown}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      inputvaluetypeid == 4
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => this.setInputType(4)}
                ></img>
              </Tooltip>
              <Tooltip title="Multi-select" placement="top-start">
                <img
                  src={checkboxIcon}
                  style={{
                    marginRight: 16,
                    cursor: "pointer",
                    border:
                      inputvaluetypeid == 5
                        ? "2px solid #1e8ced"
                        : "2px solid transparent",
                    borderRadius: 20,
                  }}
                  onClick={() => this.setInputType(5)}
                ></img>
              </Tooltip>
            </div>
            {this.state.questioninputoption &&
              inputvaluetypeid == 4 &&
              this.state.questioninputoption.map((x, i) => (
                <Grid container>
                  <Grid item md={11} sm={12}>
                    <DynamicForm
                      fields={textinputconverter({
                        value: x.optionname,
                        placeholder: "",
                        label: `Option ${i + 1}`,
                      })}
                      onChange={(e) => {
                        this.handleChange("optionname", e, i);
                      }}
                    />
                  </Grid>
                  <Grid item md={1} sm={12}>
                    <img
                      src={deleteIcon}
                      style={{
                        marginLeft: 16,
                        marginTop: 26,
                        cursor: "pointer",
                      }}
                      onClick={() => this.removeOption(i)}
                    ></img>
                  </Grid>
                </Grid>
              ))}
            {inputvaluetypeid == 4 && (
              <Button
                className="btn btn-secondary-md-blue width100"
                onClick={() => this.addOption()}
                style={{ marginBottom: 64 }}
              >
                Add option
              </Button>
            )}
            {this.state.questioninputoption &&
              inputvaluetypeid == 5 &&
              this.state.questioninputoption.map((x, i) => (
                <Grid container>
                  <Grid item md={11} sm={12}>
                    <DynamicForm
                      fields={textinputconverter({
                        value: x.optionname,
                        placeholder: "",
                        label: `Item ${i + 1}`,
                      })}
                      onChange={(e) => {
                        this.handleChange("optionname", e, i);
                      }}
                    />
                  </Grid>
                  <Grid item md={1} sm={12}>
                    <img
                      src={deleteIcon}
                      style={{
                        marginTop: 26,
                        marginLeft: 16,
                        cursor: "pointer",
                      }}
                      onClick={() => this.removeOption(i)}
                    ></img>
                  </Grid>
                </Grid>
              ))}
            {inputvaluetypeid == 5 && (
              <div>
                <Button
                  className="btn btn-secondary-md-blue width100"
                  onClick={() => this.addOption()}
                  style={{ marginBottom: 64 }}
                >
                  Add item
                </Button>
              </div>
            )}
            {/* <div style={{ width: 400, marginTop: 16 }}>
            <DynamicForm
              fields={checkboxinputconverter({
                value: saveincompany,
                placeholder: "",
                label: "Save in Company & Culture questions",
              })}
              onChange={(e) => {
                this.handleChange(e, "saveincompany", idx);
              }}
            />
          </div> */}
          </div>
          {/* {questioncategoryid != null && (
          <Button
            color="primary"
            variant="contained"
            type="button"
            className="btn btn-secondary-md-blue margin-top-8"
          // onClick={this.onSave}
          >
            Add question
          </Button>
        )} */}
          <div
            className="width100"
            style={{
              position: "fixed",
              left: 0,
              background: "white",
              bottom: 0,
              padding: 10,
              borderTop: "1px solid #d4d4d4",
              zIndex: 0,
            }}
          >
            <div>
              <div className="floatleft" style={{ marginLeft: 304 }}>
                <Button
                  className="btn btn-trans margin-right-16"
                  variant="contained"
                  onClick={this.onCancel}
                >
                  Cancel
                </Button>
              </div>
              <div className="floatright" style={{ marginRight: 72 }}>
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={this.onSave}
                >
                  Save
                </Button>
              </div>
              <div className="clearfloat"></div>
            </div>
          </div>
        </div>
        <div style={{ marginLeft: 20 }}>
          <div className="t-bold margin-bottom-8">Preview</div>

          {(questiontext && inputvaluetypeid == 4) || inputvaluetypeid == 5 ? (
            <DynamicForm
              fields={selectinputconverter({
                label: questiontext,
                options:
                  questioninputoption &&
                  questioninputoption.map((x) => ({
                    ...x,
                    displayname: x.optionname,
                  })),
              })}
              onChange={(e) => {}}
            />
          ) : (
            <DynamicForm
              fields={textinputconverter({
                value,
                placeholder,
                label: questiontext,
                disabled: true,
              })}
              onChange={(e) => {}}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(AddScreeningQuestions));
